import { sizes } from 'src/theme'
import { PartialRecord } from 'src/types/custom'

import { SImage, SImageFormat } from '../../rest/types/api/Image'
import { api } from '../../configuration'
import { ImageProps } from '../../components/Picture'

type Sizes = keyof typeof sizes

export const unwrapMedia = (media: any) => media?.data ?? media

export function ImageTransformer(
  data?: SImage,
  imageSizes?: PartialRecord<Sizes, string>
): ImageProps | undefined {
  const attrs: any = (data as any)?.attributes ?? data
  if (!attrs?.url) return undefined

  const formats: SImageFormat[] = Object.values(attrs?.formats || {})
    .filter(
      (format): format is SImageFormat =>
        format !== null && format !== undefined
    )
    .filter((format) => format.mime === 'image/webp')
    .sort((a, b) => (a?.width ?? 0) - (b?.width ?? 0))

  const sizesStr = imageSizes
    ? Object.keys(imageSizes)
        .reduce(
          (acc, size) => [
            ...acc,
            `(max-width: ${sizes[size as keyof typeof sizes]}px) ${
              imageSizes[size as keyof typeof sizes]
            }`,
          ],
          [] as Array<string>
        )
        .join(', ')
    : null

  return {
    src: `${api.ASSETS_BASE_URL}${attrs.url}`,
    alt: attrs.alternativeText ?? '',
    ...(formats?.length > 0 && {
      srcSet: formats
        .map((format) => {
          return `${api.ASSETS_BASE_URL}${format.url} ${format.width}w`
        })
        .filter((entry) => entry)
        .join(', '),
    }),
    width: attrs.width,
    height: attrs.height,
    ...(sizesStr && {
      sizes: sizesStr,
    }),
  }
}

export const UrlImageTransformer = (url: string) => {
  return api.ASSETS_BASE_URL + url
}

export const ImageCaption = (image?: SImage) => {
  const attrs: any = (image as any)?.attributes ?? image
  return attrs?.caption || ''
}
